import { render } from "./LightingCheck.vue?vue&type=template&id=38f963a0&scoped=true&ts=true"
import script from "./LightingCheck.vue?vue&type=script&lang=ts"
export * from "./LightingCheck.vue?vue&type=script&lang=ts"

import "./LightingCheck.vue?vue&type=style&index=0&id=38f963a0&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f963a0"]])

export default __exports__